import React, { useState, useEffect, useImperativeHandle } from 'react';
import { i18n } from 'fishx';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Form, Icon, Button, message } from '@whalecloud/fdx';
import { renderFormItems } from '@/utils';

import { getEmailFormItems } from './utils';
import styles from './index.module.less';

const EmailForm = props => {
  const { offerInfo, form, refInstance, onChange, tabKey, activeDepPlanPanels, onCollapseChange } = props;
  const { getFieldDecorator, validateFields } = form;
  const [maxNum, setMaxNum] = useState();
  const [emailArr, setEmailArr] = useState([{
    email: '',
    operationType: 'A', // 新开是A
    key: Math.random(),
  }]);

  useImperativeHandle(refInstance, () => ({
    getEmailArr: async() => {
      await validateFields((err, value) => {
        if (err) {
          activeDepPlanPanels.push(tabKey);
          onCollapseChange([...new Set(activeDepPlanPanels)]); // 去重
        }
      });
      return emailArr;
    },
  }));

  useEffect(() => {
    const attrDtoList = get(offerInfo, 'attrDtoList') || [];
    if (!isEmpty(attrDtoList)) {
      const maxNumAttr = attrDtoList.find(it => it.attrCode === 'EXP_EMAIL_MAXNUM') || {};
      setMaxNum(maxNumAttr.defaultValue);
    }
  }, [offerInfo]);

  const handleEmailAdd = () => {
    if (maxNum && emailArr.length >= maxNum) {
      message.warn(i18n('EMAIL_MAX_NUM_WARN'));
      return;
    }
    setEmailArr([...emailArr, {
      email: '',
      operationType: 'A', // 新开是A
      key: Math.random(),
    }]);
  };

  const handleEmailDetete = i => {
    setEmailArr(emailArr.filter((it, index) => index !== i));
  };

  const handleEmailChange = (e, index) => {
    const text = e.target.value;
    emailArr[index].email = text;
    onChange(emailArr);
  };

  return (
    <Form layout="inline" className={styles.emailFormBox}>
      {
        emailArr.map((it, index) => (
          <div className={styles.emailItemBox} key={it.key}>
            {renderFormItems(getEmailFormItems(it, index, handleEmailChange), getFieldDecorator)}
            {
              index > 0 && (
                <Icon type="minus-circle" className={styles.deleteIcon} onClick={() => handleEmailDetete(index)} />
              )
            }
          </div>
        ))
      }
      <div className={styles.emailAddBtn}>
        <Button type="dashed" icon="plus" onClick={handleEmailAdd}>
          {i18n('ADD_EMAIL_ID')}
        </Button>
      </div>
    </Form>
  );
};

const Component = Form.create({})(EmailForm);

export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
